// Pure SPA: prerender the shell and disable SSR. The trade view is
// stateful and intended to be data-driven from WebSocket feeds, so we
// don't need server rendering — just a fast static shell.
export const prerender = true;
export const ssr = false;
export const trailingSlash = 'never';
